module.exports = __webpack_public_path__ + "img/u4376.6749c216.svg";